(() => {
  const GROUP_ORDER = ['black', 'white', 'pink', 'red', 'blue', 'green', 'beige', 'brown', 'grey', 'purple', 'yellow', 'orange', 'gold', 'silver', 'prints', 'other'];
  const GROUP_LABELS = {
    black: 'Black', white: 'White', pink: 'Pink', red: 'Red', blue: 'Blue', green: 'Green',
    beige: 'Beige', brown: 'Brown', grey: 'Grey', purple: 'Purple', yellow: 'Yellow',
    orange: 'Orange', gold: 'Gold', silver: 'Silver', prints: 'Prints', other: 'Other'
  };

  const normalize = (value = '') => String(value)
    .replace(/\([^)]*\)\s*$/, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const groupFor = (raw) => {
    const value = normalize(raw);
    if (!value) return 'other';
    if (/white on pink|pink|hot pink|blush|fuchsia|magenta|rose|roses|bloom/.test(value)) return 'pink';
    if (/white on blue|light blue|dust blue|dove blue|blue|navy|cobalt|azure/.test(value)) return 'blue';
    if (/white on black|black/.test(value)) return 'black';
    if (/off[- ]?white|ivory|cream|^white$/.test(value)) return 'white';
    if (/green|pistachio|mint|olive|khaki/.test(value)) return 'green';
    if (/red|burgundy|cherry|strawberr|poppy|poppies/.test(value)) return 'red';
    if (/beige|sand|nude|ecru|oat/.test(value)) return 'beige';
    if (/brown|chocolate|camel|caramel/.test(value)) return 'brown';
    if (/grey|gray|charcoal/.test(value)) return 'grey';
    if (/purple|lavender|lilac|violet|plum/.test(value)) return 'purple';
    if (/yellow|lemon/.test(value)) return 'yellow';
    if (/orange|terracotta|rust/.test(value)) return 'orange';
    if (/metallic gold|gold/.test(value)) return 'gold';
    if (/metallic silver|silver/.test(value)) return 'silver';
    if (/checkered|check|dots|polka|floral|flower|pansies|bouquet|bouquets|print|zebra|leopard/.test(value)) return 'prints';
    return 'other';
  };

  const makeButton = (group, inputs) => {
    const availableInputs = inputs.filter((input) => !input.disabled || input.checked);
    if (!availableInputs.length) return null;

    const active = inputs.some((input) => input.checked);
    const swatchClass = group === 'prints' ? 'multicolor' : group;
    const button = document.createElement('button');

    button.type = 'button';
    button.className = `sleeper-color-option${active ? ' is-active' : ''}`;
    button.dataset.colorGroup = group;
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.innerHTML = `<span class="sleeper-color-swatch swatch-${swatchClass}" aria-hidden="true"></span><span>${GROUP_LABELS[group] || group}</span>`;

    button.addEventListener('click', () => {
      const shouldCheck = !availableInputs.some((input) => input.checked);

      availableInputs.forEach((input) => {
        input.checked = shouldCheck;
      });

      button.classList.toggle('is-active', shouldCheck);
      button.setAttribute('aria-pressed', shouldCheck ? 'true' : 'false');

      availableInputs[0].dispatchEvent(new Event('input', { bubbles: true }));
    });

    return button;
  };

  const renameHeading = (root) => {
    root.querySelectorAll('summary span, summary div, .mobile-facets__summary span, .facets__summary span, h3, .caption-large').forEach((node) => {
      if (normalize(node.textContent) === 'filter color') node.textContent = 'Color';
    });
  };

  const enhance = (root) => {
    if (!root || root.querySelector('[data-sleeper-color-filter]')) return;

    const inputs = [...root.querySelectorAll('input[type="checkbox"]')];
    if (!inputs.length) return;

    const groups = new Map();
    inputs.forEach((input) => {
      const group = groupFor(input.value);
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push(input);
    });

    const rawList =
      inputs[0].closest('ul') ||
      root.querySelector('.mobile-facets__filter-list') ||
      inputs[0].parentElement;

    if (!rawList || !rawList.parentNode) return;

    const semantic = document.createElement('div');
    semantic.className = 'sleeper-semantic-colors';
    semantic.setAttribute('data-sleeper-color-filter', '');

    GROUP_ORDER.forEach((group) => {
      const groupInputs = groups.get(group);
      if (!groupInputs?.length) return;

      const button = makeButton(group, groupInputs);
      if (button) semantic.appendChild(button);
    });

    if (!semantic.childElementCount) return;

    rawList.parentNode.insertBefore(semantic, rawList);
    rawList.classList.add('sleeper-color-native');
    renameHeading(root);
  };

  const run = () => {
    document.querySelectorAll('[data-filter]').forEach((root) => {
      const filterName = normalize(root.getAttribute('data-filter'));
      if (filterName.includes('color')) enhance(root);
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
